/**
 * Shared SportsFuture UI language — lifted from the One World hub look.
 * Import these class tokens (or components that embed them) so pages share
 * one visual system instead of one-off page styles.
 */
export const SF_UI = {
  /** Marker class for structural verification of the shared system */
  systemId: 'sf-ui-system',

  /** Immersive dark page hero shell (slate → primary → slate) */
  heroShell:
    'sf-page-hero relative overflow-hidden bg-gradient-to-br from-slate-950 via-primary-900 to-slate-900 text-white pt-28 pb-16',

  heroOrbPrimary:
    'pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary/30 blur-3xl',

  heroOrbSecondary:
    'pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-secondary/20 blur-3xl',

  heroOrbSoft:
    'pointer-events-none absolute left-1/2 top-1/3 h-40 w-40 -translate-x-1/2 rounded-full bg-white/5 blur-2xl',

  /** Uppercase micro-label above titles */
  microLabel:
    'sf-micro-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-200',

  microLabelOnLight:
    'sf-micro-label text-xs font-semibold uppercase tracking-[0.25em] text-primary',

  heroTitle: 'text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight',

  heroSubtitle: 'text-base sm:text-lg md:text-xl text-slate-200 max-w-2xl mx-auto',

  /** Soft content band under heroes */
  sectionBand: 'bg-slate-50',

  /** Primary elevated surface card */
  surfaceCard:
    'sf-surface-card bg-white rounded-2xl shadow-md border border-gray-100',

  surfaceCardHover:
    'sf-surface-card bg-white rounded-2xl shadow-md border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl',

  surfaceCardPad: 'p-6 md:p-8',

  /** Primary CTA radius / elevation language */
  ctaPrimary:
    'sf-cta inline-flex items-center justify-center rounded-xl bg-primary px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-600',

  ctaSecondary:
    'sf-cta inline-flex items-center justify-center rounded-xl border border-secondary/40 bg-white px-5 py-3 text-sm font-semibold text-secondary-700 shadow-sm transition hover:bg-secondary-50',

  /** Global chrome */
  headerShell: 'sf-chrome-header bg-white/95 backdrop-blur-md border-b border-slate-100/80',

  footerShell:
    'sf-chrome-footer bg-gradient-to-br from-slate-950 via-slate-900 to-primary-900 text-white',
} as const;

export type SfUiTokens = typeof SF_UI;
